import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import SDK from "../../config";
import handlePaymentSuccessLifetime from "../checkoutPageComponent/handlePaymentSuccessLifetime";

export const useCheckoutForm = (stripe) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [zipcode, setZipcode] = useState(localStorage.getItem("zipcode") || "");
  const [cardName, setCardName] = useState("");
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [canMakePayment, setCanMakePayment] = useState(false);
  const [baseURL, setBaseUrl] = useState(false);
  const [regionText, setRegionText] = useState(SDK.REGION_CONFIG.us);
  const [selectedPlan, setSelectedPlan] = useState(() => {
    const stored = SDK.getSelectedPlan();
    return stored || { type: "Lifetime", pageType: "lifetime", price: 69 };
  });
  // Initialize selected plan
  useEffect(() => {
    const plan = SDK.getSelectedPlan();
    if (!plan) {
      navigate("/");
      toast.error("No plan selected.");
      return;
    }
    setBaseUrl(SDK.getBaseUrl(plan.pageType));
    setSelectedPlan(plan);
  }, []);
  const getCurrencySymbol = () => {
    const saveRegion = (localStorage.getItem("region") || "us").toLowerCase();
    switch (saveRegion) {
      case "us":
        return "$";
      case "uk":
        return "£";
      case "eu":
        return "€";
      default:
        return "$";
    }
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    localStorage.setItem("email", newEmail || email);
  };

  // Initialize email from URL params
  useEffect(() => {
    const useremail = params.get("email");
    if (useremail) {
      setEmail(useremail);
      localStorage.setItem("email", useremail);
    }
  }, [location]);

  // Initialize region
  useEffect(() => {
    const saveRegion = (localStorage.getItem("region") || "us").toLowerCase();
    const region = SDK.REGION_CONFIG[saveRegion];
    setRegionText(region);
  }, []);

  // Setup payment request
  useEffect(() => {
    if (!stripe || !selectedPlan || !baseURL) return;

    const paymentOf = "iOS";
    const type = SDK.PAGE_TYPE;
    const saveRegion = localStorage.getItem("region") || "us";
    const { currency, price, countryCode } =
      SDK.REGION_CONFIG[saveRegion] || SDK.REGION_CONFIG["us"];
    // const amount =selectedPlan.price * 100;
    const amount = 0 * 100;
    const paymentRequestInstance = stripe.paymentRequest({
      country: countryCode,
      currency: currency,
      total: {
        label: "Total",
        amount: amount,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    paymentRequestInstance
      .canMakePayment()
      .then((result) => {
        setCanMakePayment(result);
        setPaymentRequest(paymentRequestInstance);
      })
      .catch((error) => {
        console.error("Error checking PaymentRequest support:", error);
      });

    paymentRequestInstance.on("paymentmethod", async (event) => {
      const { paymentMethod, payerEmail } = event;
      // const price = selectedPlan.price * 100;
      const price = 0 * 100;

      try {
        const response = await fetch(
          `${baseURL}/api/create-payment-intent-apple-pay`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              payment_method_id: paymentMethod.id,
              email: payerEmail,
              paymentOf,
              regionCur: currency,
              type,
              price,
              selectedPlan,
            }),
          }
        );
        const { client_secret: clientSecret } = await response.json();
        if (!clientSecret) {
          throw new Error("Client secret not returned from backend");
        }
        const { error, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: paymentMethod.id,
          }
        );

        if (error) {
          console.error("Payment confirmation error:", error);
          event.complete("fail");
          return;
        }

        event.complete("success");

        const storeEmail = payerEmail;
        const storeZipcode = localStorage.getItem("zipcode");
        const methodType = "Apple Pay";
        const paymentWay = "iOS";

        const res = await handlePaymentSuccessLifetime(
          paymentIntent,
          methodType,
          storeEmail,
          storeEmail,
          storeZipcode,
          paymentWay
        );

        if (res) {
          if (window.mootrack) {
            window.mootrack("purchesed", email);
          }
          navigate(`/confirmation?email=${encodeURIComponent(storeEmail)}`);
          SDK.clearAllLocalStorage();
          toast.success("Payment Successful");
        } else {
          toast.error("Payment Failed");
          event.complete("fail");
        }
      } catch (error) {
        event.complete("fail");
        console.error("Unexpected error during payment processing:", error);
      }
    });
  }, [stripe, navigate, selectedPlan, baseURL]);

  return {
    email,
    zipcode,
    cardName,
    showCardDetails,
    pageLoader,
    paymentRequest,
    canMakePayment,
    regionText,
    selectedPlan,
    setCardName,
    setShowCardDetails,
    setPageLoader,
    handleEmailChange,
    getCurrencySymbol,
  };
};
